import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';
import { ArticleColours } from '../react/product/colourChange';

export const angularEvents = {
  // Without data
  fooBar: new SignalDispatcher(),
  fooBar2: new SimpleEventDispatcher<number>(),
  isEditing: new SimpleEventDispatcher<boolean>(),
  saveArticle: new SignalDispatcher(),
  articleColoursHasChanged: new SimpleEventDispatcher<ArticleColours>(),
  userIsAuthenticated: new SignalDispatcher(),
  productImportViewLoaded: new SignalDispatcher()
};

// Example
const unsubscribe = angularEvents.fooBar2.subscribe((a) => { console.log(a)});
angularEvents.fooBar2.dispatch(3);
unsubscribe();

// =============================
// check ste-simple-events docs
// =============================